module.exports = __webpack_public_path__ + "img/logo2.0daec8ba.png";